import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Row, Container, Col, Card, CardBody, Label } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb2"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { useDispatch, useSelector } from "react-redux"
import Report3ListTable from "components/Reports/Report3ListTable"
import {
  getCourses,
  listReport3,
  listReport3Clean,
  getUsers,
  getGroups,
  getCustomers,
} from "store/actions"
import { LoadingIndicator } from "components/Common/LoadingIndicator"
import XlsExporter from "components/Common/XlsExporter"
import ReportFilters from "components/Reports/ReportFilters"
import Report3Chart from "components/Reports/Report3Chart"

const Report3 = props => {
  const dispatch = useDispatch()

  const [statusCurso, setStatusCurso] = useState(0)
  const [statusUsuario, setStatusUsuario] = useState(0)
  const [submit, setSubmit] = useState(false)
  const [reportInfo, setReportInfo] = useState([])

  const {
    error,
    loading,
    done,
    report,
    courses,
    users,
    customers,
    groups,
    whoIAm,
  } = useSelector(state => ({
    error: state.Report3List.error,
    loading: state.Report3List.loading,
    report: state.Report3List.report,
    done: state.Report3List.done,
    courses: state.CoursesList.coursesManagement,
    users: state.UsersList.users,
    customers: state.CustomersList.customers,
    groups: state.GroupsList.groups,
    whoIAm: state.Profile.user,
  }))

  useEffect(() => {
    dispatch(getCourses())
    dispatch(getUsers())
    dispatch(getGroups())
    dispatch(getCustomers())
  }, [])

  const getStatusByValue = status => {
    if (parseInt(status) === 1) return true
    if (parseInt(status) === 2) return false
    return null
  }

  const onSubmit = data => {
    dispatch(listReport3({ ...data, status: true, userId: whoIAm.idUsuario }))
  }

  const getXlsData = report => {
    let data = report.map((element, index) => {
      return {
        "Nombre(s)": element.nombre_usuario,
        "Apellido(s)": element.apellido_usuario,
        "Correo electrónico": element.Email,
        Perfil: `N${element.IdRol}`,
        Estatus: element.Id_status ? "Activado" : "Desactivado",
        Grupo: element.nombre_grupo,
        Distribuidor: element.nombre_distribuidor,
        "Cursos asignados": element.total_cursos_asignados,
        "Cursos aprobados": element.cursos_aprobados,
        "Cursos en proceso": element.cursos_en_proceso,
        "Cursos faltantes": element.cursos_faltantes,
        "Porcentaje de aprobación":
          Math.round((element.porcentaje_aprobacion + Number.EPSILON) * 100) /
          100,
        "Porcentaje de avance":
          Math.round((element.porcentaje_avance + Number.EPSILON) * 100) / 100,
      }
    })

    return {
      Reporte3: data,
    }
  }

  if (done) {
    setSubmit(true)
    setReportInfo(report)
    dispatch(listReport3Clean())
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>
            Reporte 3 - Estatus de cursos por usuarios | Capacitación en Línea
            Fester
          </title>
        </MetaTags>
        <Container fluid>
          <Row>
            <Col sm={4}>
              <h4>Reporte 3 - Estatus de cursos por usuarios</h4>
            </Col>
            <Col sm={8}>
              <Breadcrumbs
                breadcrumbItems={[
                  { key: "dashboard", title: "Dashboard", link: "/dashboard" },
                  { key: "Reports", title: "Analítica", link: "/reports" },
                  { key: "Report3", title: "Reporte 3" },
                ]}
              />
            </Col>
          </Row>

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  {error !== "" && (
                    <div className="alert alert-danger mb-3">
                      Ocurrió un error al solicitar la información.
                    </div>
                  )}
                  <ReportFilters
                    title="Reporte 3"
                    onSubmit={values => onSubmit(values)}
                    xlsButton={
                      <XlsExporter
                        classNames={`btn btn-light mt-2 btn-block ${
                          submit ? "" : "disabled"
                        }`}
                        data={getXlsData(reportInfo)}
                        dataName={"Reporte3"}
                        name="Reporte 3"
                        label="Exportar"
                      />
                    }
                    users={users}
                    courses={courses}
                    customers={customers}
                    groups={groups}
                  />
                  {!loading && !submit && <div style={{ height: 260 }}></div>}
                  {loading && (
                    <div className="d-flex justify-content-center">
                      <LoadingIndicator />
                    </div>
                  )}
                  {!loading && submit && (
                    <div className="mt-4">
                      <Report3Chart data={reportInfo} />
                      <br />
                      <Report3ListTable loading={loading} report={reportInfo} />
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Report3
